// Press logos rendered white-on-transparent for dark backgrounds.

import azBigMedia from "@/assets/press/az-big-media.png.asset.json";
import condeNast from "@/assets/press/conde-nast.png.asset.json";
import eatThisNotThat from "@/assets/press/eat-this-not-that.png.asset.json";
import insideOutdoor from "@/assets/press/inside-outdoor.png.asset.json";
import modernLuxuryScottsdale from "@/assets/press/modern-luxury-scottsdale.png.asset.json";
import travelLeisure from "@/assets/press/travel-leisure.png.asset.json";
import trazeeTravel from "@/assets/press/trazee-travel.png.asset.json";
import tripadvisor from "@/assets/press/tripadvisor.png.asset.json";
import urbandaddy from "@/assets/press/urbandaddy.png.asset.json";
import usNews from "@/assets/press/us-news.png.asset.json";
import yahooLife from "@/assets/press/yahoo-life.png.asset.json";

export type PressLogo = {
  name: string;
  /** White-on-transparent PNG, sized for dark backgrounds. */
  logo?: string;
  /** Legacy: optional wordmark path. Prefer `logo`. */
  wordmark?: string;
};

export const pressLogos: PressLogo[] = [
  { name: "Condé Nast", logo: condeNast.url },
  { name: "Travel + Leisure", logo: travelLeisure.url },
  { name: "Eat This, Not That!", logo: eatThisNotThat.url },
  { name: "Trazee Travel", logo: trazeeTravel.url },
  { name: "Inside Outdoor", logo: insideOutdoor.url },
  { name: "Modern Luxury Scottsdale", logo: modernLuxuryScottsdale.url },
  { name: "AZ Big Media", logo: azBigMedia.url },
  { name: "U.S. News & World Report", logo: usNews.url },
  { name: "UrbanDaddy", logo: urbandaddy.url },
  { name: "Yahoo Life", logo: yahooLife.url },
  { name: "Tripadvisor", logo: tripadvisor.url },
];

export const pressQuote = {
  quote:
    "A rare kind of quiet luxury — the dark sky here doesn't just sparkle, it overwhelms.",
  outlet: "Condé Nast Traveler",
};

export const rating = {
  score: 4.9,
  count: 312,
  source: "Verified guest reviews",
};

export const bookingUrl = "#book";
